// Copyright (c) 2017 Deere & Company

import PartialDebit from './partial-debit';
import actionCreators from '../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.tcsm.partialDebit
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    goBack: parentProps.history.goBack,
    queryParams: parentProps.location.query,
    routeParams: parentProps.routeParams
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PartialDebit);



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/index.js